import React from 'react';
import { Card, CardContent, Box, Typography, Link, IconButton, alpha, useTheme } from '@mui/material';
import { Business, Email, OpenInNew, Person, Close } from '@mui/icons-material';
import { openExternal } from '../../../utils/openExternal';
import { useSelector } from 'react-redux';
import { getCrmMeta } from '../../../utils/crmUtils';
import { selectCrmCatalog } from '../../../state/integration/integrationSlice';

const CrmContactCard = ({ contact, crmType, onClose }) => {
    const theme = useTheme();
    const crmCatalog = useSelector(selectCrmCatalog);
    const crm = getCrmMeta(crmType, crmCatalog[crmType]);

    if (!contact) return null;

    return (
        <Card
            sx={{
                width: '280px',
                borderRadius: 4,
                backgroundColor: alpha(theme.palette.background.paper, 0.75),
                backdropFilter: 'blur(8px)',
                border: `1px solid ${alpha(crm.primary, 0.25)}`,
                borderTop: `3px solid ${crm.primary}`,
            }}
        >
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Person sx={{ fontSize: 18, color: crm.primary }} />
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, color: crm.primary, fontWeight: 600 }}>
                            {crm.label}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {contact.profileUrl && (
                            <Link
                                component="button"
                                onClick={() => openExternal(contact.profileUrl)}
                                sx={{ display: 'flex', alignItems: 'center', gap: 0.3, fontSize: 11, color: crm.primary }}
                            >
                                Open <OpenInNew sx={{ fontSize: 11 }} />
                            </Link>
                        )}
                        {onClose && (
                            <IconButton size="small" onClick={onClose} sx={{ p: 0.25, color: 'text.secondary', ml: 0.5 }}>
                                <Close sx={{ fontSize: 14 }} />
                            </IconButton>
                        )}
                    </Box>
                </Box>

                <Typography variant="h6" sx={{ mb: 1 }}>
                    {contact.name}
                </Typography>

                {contact.company && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                        <Business sx={{ fontSize: 14, color: 'text.secondary' }} />
                        <Typography variant="body2" color="text.secondary">{contact.company}</Typography>
                    </Box>
                )}

                {contact.email && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                        <Email sx={{ fontSize: 14, color: 'text.secondary' }} />
                        <Typography variant="body2" color="text.secondary">{contact.email}</Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default CrmContactCard;